import classNames from 'classnames';

import { ImageLoadable, UploadedImageFile } from '@anyx/feature-crm/shared';


import { UrlAction, isManualActionURL } from '../line-message-form';

export interface LineRichMessageBubbleProps {
  image?: UploadedImageFile;
  actionUrl?: UrlAction;
  className?: string;
}

export const LineRichMessageBubble = ({
  actionUrl,
  image,
  className,
}: LineRichMessageBubbleProps) => {
  const content = (
    <div className={classNames(className, 'aspect-square h-full overflow-hidden rounded-2xl')}>
      <ImageLoadable className="aspect-square" src={image?.src} alt={image?.name} />
    </div>
  );

  return isManualActionURL(actionUrl) ? (
    <a href={actionUrl.manual} target="_blank" rel="noreferrer">
      {content}
    </a>
  ) : (
    content
  );
};
